enum ListInquiryOrderItem {
  laCompanyCode = 'laCompanyCode',
  laCompanyName = 'laCompanyName',
  contractNo = 'contractNo',
  reLeaseCount = 'reLeaseCount',
  contractDate = 'contractDate',
  laStartDate = 'laStartDate',
  leasePeriod = 'leasePeriod',
  laExpiredDate = 'laExpiredDate',
  previousPaymentDate = 'previousPaymentDate',
  contractConditionClass = 'contractConditionClass',
  subCategoryCode = 'subCategoryCode',
  subCategoryName = 'subCategoryName',
  contractName = 'contractName',
  estimateCashPurchaseAmount = 'estimateCashPurchaseAmount',
  specialItemOne = 'specialItemOne',
  specialItemTwo = 'specialItemTwo',
  paymentMethod = 'paymentMethod',
  laFirstFee = 'laFirstFee',
  laFirstFeeInTax = 'laFirstFeeInTax',
  laPaymentFee = 'laPaymentFee',
  laPaymentFeeInTax = 'laPaymentFeeInTax',
  laLastFee = 'laLastFee',
  laLastFeeInTax = 'laLastFeeInTax',
  totalLeaseFee = 'totalLeaseFee',
  consumptionTaxOverAllAmount = 'consumptionTaxOverAllAmount',
  contractSpareNameOne = 'contractSpareNameOne',
  contractSpareNameTwo = 'contractSpareNameTwo',
  conclusionApprovalNo = 'conclusionApprovalNo',
  conclusionSummary = 'conclusionSummary',
  articleNoParent = 'articleNoParent',
  articleNoBranch = 'articleNoBranch',
  articleNo = 'articleNo',
  articleName = 'articleName',
  articleSpareNameOne = 'articleSpareNameOne',
  articleSpareNameTwo = 'articleSpareNameTwo',
  articleConditionClass = 'articleConditionClass',
  cancelDate = 'cancelDate',
  treatmentAfterExpiration = 'treatmentAfterExpiration',
  quantity = 'quantity',
  quantityUnit = 'quantityUnit',
  leaseFeeDistributionRatio = 'leaseFeeDistributionRatio',
  articleAmount = 'articleAmount',
  guaranteedResidualValue = 'guaranteedResidualValue',
  noteOne = 'noteOne',
  noteTwo = 'noteTwo',
  acquiredMerger = 'acquiredMerger',
  acquiredMergerDate = 'acquiredMergerDate',
  paymentDate = 'paymentDate',
  categoryCode = 'categoryCode',
  locationCode = 'locationCode',
}

export const listInquiryOrderItem = {
  enum: ListInquiryOrderItem,
};
